"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainContext = void 0;
const hash = require("./hash");
const misc = require("./misc");
async function chainContext(doc) {
    return misc.toHex(await hash.hash(misc.toCBOR(doc)));
}
exports.chainContext = chainContext;
